import { type IHydratedWidget } from '@framework/engine/hydrate/IHydrationContext.ts';
import { generateMarginStyle } from '@framework/engine/schema/directives/margin/generateMarginStyle.ts';
import { type IHtmlRenderContext } from '@framework/engine/schema/widgets/IWidgetType.ts';
import { type ISectionWidget } from './ISectionWidget.ts';

function escapeAttr(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function renderSectionHtml(
  widget: IHydratedWidget<ISectionWidget>,
  context: IHtmlRenderContext,
): string {
  const placeholder =
    typeof widget.placeholder === 'string' ? widget.placeholder : '';
  const content = context.sections?.[placeholder] ?? '';
  const marginStyle = generateMarginStyle(widget.directives?.margin);
  const styleSection = marginStyle ? ` style="${marginStyle}"` : '';
  return `<div data-placeholder-section-id="${escapeAttr(placeholder)}"${styleSection}>${content}</div>`;
}
